import {useTranslation} from "ni18n";
import React, {memo} from "react";
import useMediaQuery from "src/useMediaQuery";

import {PricingTierItem} from "../../../../store/slices/regionPricing";

const PricingItem: React.FC<PricingTierItem> = ({typ, name, price, slug}) => {
  const isSm = useMediaQuery("sm");
  const i18n = useTranslation();
  const addendum = typ === "Visit" || name.match(/covid/gi) ? "" : `+ ${i18n.t("visit price")}`;
  const displayPrice = `$${price / 100}`;

  return (
    <li
      className="dg aic bg-white br2 pv4 pl5 pr5 ph3-md pv3-md gg4 contrast-tbb"
      style={{
        gridTemplateColumns: isSm ? "auto 1fr auto" : "auto 1fr 160px",
      }}
    >
      <span
        aria-hidden
        style={{height: 50, width: 50}}
        className={`bg-lightMint gray600 br50 tac fs24 df aic jcc contrast-tb cIcon-${slug}`}
      />
      <span className="fs20 fs16-md fs14-sm font-im ls-5 lh15">{i18n.t(name)}</span>
      <span
        className="dg df-sm fdc aic aife-sm gg2 gg0-sm gray800 font-im fs24 fs16-md lh13"
        style={{gridTemplateColumns: "auto 1fr"}}
      >
        <span>{displayPrice}</span>
        <span className="gray600 font-ir fs16 lh2 fs14-md">{addendum}</span>
      </span>
    </li>
  );
};

export default memo(PricingItem);
